// observatorio_react\src\domain\home-page\NewsSession\index.js
import React from "react";

import { LoadingCard, NewsContainer, NewsSec } from "./styles";

import { Header } from "../styles";
import { Button, ErrorAlertCard } from "../../../../components";
import { useAxios } from "../../../../hooks/useAxios";
import { CircularProgress } from "@material-ui/core";
import { NewsCarousel } from "../../../../components/NewsCarousel";
import { Link } from "react-router-dom";

function NewsSession() {
  const uri = "/noticias";

  const { loading, response, error } = useAxios({
    method: "GET",
    url: uri,
    headers: {
      accept: "*/*",
    },
  });

  return (
    <NewsSec>
      <NewsContainer>
        <Header>Notícias</Header>
        {loading ? (
          <LoadingCard>
            <CircularProgress color={"inherit"} style={{ color: "#fff" }} />
          </LoadingCard>
        ) : (
          <>
            {error && (
              <div style={{ width: "100%" }}>
                <ErrorAlertCard
                  descricao="Não foi possível carregar as notícias."
                  erroMsg={error}
                />
              </div>
            )}
            {response && (
              <>
                {response.dados.noticias_destaque.length > 0 ? (
                  <NewsCarousel noticias={response.dados.noticias_destaque} />
                ) : (
                  <p style={{ marginBottom: "23px" }}>
                    Sem notícias cadastradas
                  </p>
                )}
                <Link to="/noticias">
                  <Button primary>Ler mais notícias</Button>
                </Link>
              </>
            )}
          </>
        )}
      </NewsContainer>
    </NewsSec>
  );
}

export default NewsSession;
